import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { AsyncJobType } from '@recruitee/account-data';
import { AsyncJobActions } from '@recruitee/async-job-data';
import { ClaimStatus } from '@recruitee/http-types';
import { createEffectFactory } from '@recruitee/ngrx';

import { ApplicationsHttpClient } from './applications.http-client';
import { ReferralsApplicationsActions } from './applications.store';

@Injectable({ providedIn: 'root' })
export class ReferralsApplicationsEffects {
  public effects = createEffectFactory(ReferralsApplicationsActions, this.actions$);
  public asyncJobTypes = {
    [ClaimStatus.Open]: AsyncJobType.BulkReferralApplicationsOpen,
    [ClaimStatus.Accepted]: AsyncJobType.BulkReferralApplicationsAccept,
    [ClaimStatus.Rejected]: AsyncJobType.BulkReferralApplicationsReject,
  };

  public fetch$ = this.effects(
    ReferralsApplicationsActions.fetchPaginatedCollection,
    ({ payload }) =>
      this.applicationsHttpService.loadApplications(payload.params).pipe(
        map(data => ({
          data,
        })),
      ),
  );

  public settle$ = this.effects(ReferralsApplicationsActions.settleApplication, ({ payload }) =>
    this.applicationsHttpService.settleApplication(payload.id, payload.data).pipe(
      switchMap(data => [
        ReferralsApplicationsActions.settleApplicationSuccess({ payload: { data } }),
      ]),
      catchError((error: HttpErrorResponse) =>
        of(
          ReferralsApplicationsActions.settleApplicationFailed({
            payload: { error, data: payload },
          }),
        ),
      ),
    ),
  );

  public bulkSettle$ = this.effects(
    ReferralsApplicationsActions.bulkSettleApplication,
    ({ payload }) =>
      this.applicationsHttpService.bulkSettleApplication(payload.applicationIds, payload.data).pipe(
        switchMap(({ uuid }) => [
          AsyncJobActions.create({
            payload: { job: { uuid, type: this.asyncJobTypes[payload.data] } },
          }),
          ReferralsApplicationsActions.bulkSettleApplicationSuccess({
            payload: { uuid },
          }),
        ]),
        catchError(error =>
          of(
            ReferralsApplicationsActions.bulkSettleApplicationFailed({
              payload: { error },
            }),
          ),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private applicationsHttpService: ApplicationsHttpClient,
  ) {}
}
